<div class="dark-blue">
  <nestas-toolbar [steps]="steps"></nestas-toolbar>
</div>
<div cdkScrollable class="wrap contractor-component">
  <div *ngIf="!contractors.display.length">
    <mat-spinner *ngIf="!contractors.display.length" style="margin-left:30px;"></mat-spinner>
  </div>
  <nestas-searchbar (search)="filterContractor($event)"
    [placeholder]="translate.instant('CONTRACTOR.SEARCH_CONTRACTORS')" class="flexbox wrap-search"></nestas-searchbar>

  <mat-card *ngIf="contractors.display.length">

    <mat-card-title>{{translate.instant('CONTRACTOR.CONTRACTORS')}}</mat-card-title>
    <mat-slide-toggle [(ngModel)]="showHidden" color="primary">{{translate.instant('CONTRACTOR.SHOW_HIDDEN')}}
    </mat-slide-toggle>

    <table mat-table class="default-table tight">
      <tr>
        <th>{{translate.instant('DATA.NAME')}}</th>
        <th>{{translate.instant('DATA.EMAIL')}}</th>
        <th>{{translate.instant('DATA.PHONE')}}</th>
        <th>{{translate.instant('DATA.OWNER')}}</th>
        <th>{{translate.instant('CONTRACTOR.HIDE')}}</th>
      </tr>
      <ng-container *ngFor="let ft of contractors.display; let i = index">
        <tr *ngIf="!ft.hidden || showHidden">
          <td>
            <mat-form-field [ngClass]="{'fill' : isReadOnly(ft), 'readonly': isReadOnly(ft)}">
              <input matInput [readonly]="isReadOnly(ft)" [(ngModel)]="ft.name" (ngModelChange)="nameChanged($event, i)"
                type="text">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field *ngIf="!isReadOnly(ft)" class="fill">
              <input matInput [(ngModel)]="ft.email" type="text">
            </mat-form-field>
            <input matInput *ngIf="isReadOnly(ft)" readonly="readonly" [(ngModel)]="ft.email" type="text">
          </td>
          <td>
            <mat-form-field *ngIf="!isReadOnly(ft)" class="fill">
              <input matInput [(ngModel)]="ft.phone" type="text"> 
            </mat-form-field>
            <input matInput *ngIf="isReadOnly(ft)" readonly="readonly" [(ngModel)]="ft.phone" type="text">
          </td>
          <td>
            {{ft.profile && ft.profile.email}}
          </td>
          <td>
            <mat-checkbox *ngIf="!isReadOnly(ft)" [(ngModel)]="ft.hidden"></mat-checkbox>
          </td>
        </tr>
      </ng-container>

    </table>
    <mat-card-actions align="end" class="clear-margin save-button">
      <!--<button mat-raised-button color="primary" (click)="addContractor()">
        {{translate.instant('BUTTON.ACTION.ADD', {'data': 'Lijn'})}}
      </button>-->

      <button mat-raised-button color="primary" (click)="saveContractors()">
        {{translate.instant('BUTTON.ACTION.SAVE')}}
      </button>
    </mat-card-actions>
  </mat-card>
</div>